



















































































































































































































































































































































































































































































































































































































































































































































































































































































import { Vue, Component, Prop, Emit, Watch } from 'vue-property-decorator'
import {
  DictRequest,
  DictFilter,
  DictParam, OrderOption, DictList,
  DictOptions, Certificates, DicListItem
} from '@/types'
import { EPLModule } from '@/store/eplmodule'
import { SIGNModule } from '@/store/signmodule'
import moment from 'moment'

@Component({
  name: 'DictTable',
  components: {
    DictForm: () =>
      import(/* webpackChunkName: "DictForm" */ '@/components/DictForm.vue')
  }
})
export default class DictTable extends Vue {
  rowsSelected = [] as Array<number>
  showSelect = false
  massPdfToken = ''
  massPdfStatus = 0
  massPdfTimerId = 0
  selectedEntUnits = [] as DictList
  selectedDriverOrg = null as DicListItem | null
  spp = false
  filter = ''
  currentFilter = ''
  filterString = ''
  currentFilterString = ''
  filterError = false
  pickerFrom = ''
  pickerTo = ''
  dateFrom = ''
  dateTo = ''
  period = -1
  periods = ['вчера', 'сегодня', 'завтра', 'неделя', 'месяц']
  showArchived = false
  ExtendFilter = false
  selected = [] as string[]
  options = { page: 1, itemsPerPage: 10 }
  optionsOld = '{"page": 1, "itemsPerPage": 10}'
  show = false
  idx = -1
  idxS = -1
  idxR = -1
  idxRoles = -1
  signs = [] as Array<{ name0: string, name1: string, sign0: number, sign1: number, date0: string, date1: string }>
  saveForm = false
  tzoffset = 0
  tableHeight: number | string = 0
  provider = ['']
  loadingCert = false
  certificates = [] as Certificates
  showSignXMLDialog = false
  showSignSimpleDialog = false
  myxml = [] as Array<{ key: string, val: string | null }>
  XMLtoSign = ''
  loadingSimple = false
  iPassword = ''
  iLogin = ''
  signedTask = -1
  signEventType = -1
  signCurrentId = -1
  needUpdateTable = false
  eplhours = 0
  drivertasks = 0
  dinner = 0
  downtimes = 0
  repairs = 0
  diff = 0
  dismissed = false
  deleted = false
  showCofigHeaders = false
  tableHeaders = [] as Array<any>
  enabledHeaders = [] as Array<string>
  signFilter = {
    r2: { out: false, in: false },
    r3: { out: false, in: false },
    r4: { out: false, in: false },
    r7: { out: false, in: false }
  }

  @Prop({ default: '' }) dictName!: string
  @Prop({ default: true }) showFilter!: boolean
  @Prop({ default: true }) showDel!: boolean
  @Prop({ default: false }) showDense!: boolean
  @Prop() mainFilter!: DictFilter
  @Prop({ default: false }) builtin!: boolean
  @Prop() markRow!: number
  @Prop({ default: false }) customAdd!: boolean

  @Emit('clickRow')
  clickRow (id: number) {
    if (this.mainFilter !== undefined) {
      // если таблица привязана к ЭПЛ
      EPLModule.showDictForm({ id: id, idx: this.idx })
    }
    return id
  }

  @Emit('update-parent')
  updateParent () { //
  }

  @Emit('clickAdd')
  clickAdd () { //
  }

  @Watch('signFilter', { deep: true })
  onsignFilterChange () {
    localStorage.setItem('signFilter', JSON.stringify(this.signFilter))
    if (this.show) this.changeFilter()
  }

  @Watch('driverFio')
  onDriverFioChange () {
    if (this.driverFio === '') return
    if (this.dictName === 'EPL') {
      this.currentFilterString = this.driverFio
      this.selected = ['driver1']
      this.ExtendFilter = true
      this.changeExtendFilter()
      this.applyFilter()
    }
    EPLModule.setDriverFio('')
  }

  get driverFio () {
    return EPLModule.DriverFio
  }

  get loading () {
    if (EPLModule.loading === 0) {
      const filterField = this.$refs.filterField as any
      setTimeout(() => { filterField.focus() }, 200)
    }
    return EPLModule.loading
  }

  private updmileage () {
    if (this.mainFilter && this.mainFilter.field === 'eplid') {
      EPLModule.updmileage(parseInt(this.mainFilter.condition))
        .then(() => {
          this.updateParent()
          this.changeFilter()
        })
    }
  }

  private isRowSelected (id: number) {
    return this.rowsSelected.indexOf(id) >= 0
  }

  private rowSelect (id: number) {
    const row = this.rowsSelected.indexOf(id)
    if (row >= 0) {
      this.rowsSelected.splice(row, 1)
    } else {
      this.rowsSelected.push(id)
    }
  }

  private rowsSelectAll () {
    this.dict.rows.forEach(r => {
      if (this.rowsSelected.indexOf(r.id) < 0) this.rowsSelected.push(r.id)
    })
  }

  private massPdf () {
    EPLModule.massPdf(this.rowsSelected)
      .then(t => {
        localStorage.massPdfToken = t
        this.massPdfToken = t as string
        this.showSelect = false
        this.startMassPdfTimer()
      })
  }

  private massPdfBlank () {
    EPLModule.massPdfBlank(this.rowsSelected)
      .then(t => {
        localStorage.massPdfToken = t
        this.massPdfToken = t as string
        this.showSelect = false
        this.startMassPdfTimer()
      })
  }

  private massPdfPrint () {
    EPLModule.massPdfResult(this.massPdfToken)
      .then((response: any) => {
        const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }))
        const printwWindow = window.open(url)
        if (printwWindow !== null) { printwWindow.print() }
      })
  }

  private startMassPdfTimer () {
    this.massPdfTimerId = setInterval(() => {
      if (this.massPdfToken === '') {
        clearInterval(this.massPdfTimerId)
      } else {
        EPLModule.massPdfStatus(this.massPdfToken)
          .then((res: any) => {
            this.massPdfStatus = res.data.status
            if (this.massPdfStatus === 100) clearInterval(this.massPdfTimerId)
          })
          .catch(e => {
            localStorage.massPdfToken = ''
            clearInterval(this.massPdfTimerId)
          })
      }
    }, 1000)
  }

  get isShowForm () {
    if (!this.dict.isShowForm) {
      if (this.needUpdateTable) {
        this.needUpdateTable = false
        this.changeFilter()
      }
    }
    return this.dict.isShowForm
  }

  public updateTable () {
    if (this.dictName === 'DriverTasks') {
      this.updateParent()
    }
    this.needUpdateTable = true
  }

  @Watch('options', { deep: true })
  onOptionsChange () {
    let optionsNew = JSON.stringify(this.options)
    if (this.optionsOld !== optionsNew) {
      // console.log('options')
      // console.log(this.optionsOld)
      // console.log(optionsNew)
      if (this.options.itemsPerPage !== JSON.parse(this.optionsOld).itemsPerPage) {
        this.options.page = 1
        optionsNew = JSON.stringify(this.options)
      }
      this.optionsOld = optionsNew
      if (this.dictName === 'EPL') {
        localStorage.Options = optionsNew
      }
      this.changeFilter()
    }
  }

  private getTimeFormat (sec: number) {
    const h = Math.trunc(sec / 60)
    const m = sec - h * 60
    let ht = `${h}`
    if (h < 10) ht = '0' + h
    let mt = `${m}`
    if (m < 10) mt = '0' + m
    return `${ht}:${mt}`
  }

  private Wait () {
    return new Promise<void>(resolve => {
      setTimeout(() => { resolve() }, 500)
    })
  }

  private toggleHeaders (h: string) {
    if (this.enabledHeaders.includes(h)) {
      this.enabledHeaders.splice(this.enabledHeaders.indexOf(h), 1)
      let idx = -1
      this.tableHeaders.forEach((th: any, i: number) => {
        if (th.value === h) {
          idx = i
        }
      })
      if (idx > -1) {
        this.tableHeaders.splice(idx, 1)
      }
    } else {
      this.enabledHeaders.push(h)
      let idx = -1
      this.dict.headers.forEach((th: any, i: number) => {
        if (th.value === h) {
          idx = i
        }
      })
      let hh = ''
      let ins = -1
      for (let x = idx; x > 0; x--) {
        if (x === 0) {
          ins = 0
        } else {
          hh = this.dict.headers[x - 1].value
          ins = -1
          this.tableHeaders.forEach((th: any, i: number) => {
            if (th.value === hh) {
              ins = i
            }
          })
        }
        if (ins >= 0) {
          this.tableHeaders.splice(ins + 1, 0, this.dict.headers[idx])
          break
        }
      }
    }
    localStorage.setItem('eplheaders', JSON.stringify(this.enabledHeaders))
  }

  beforeDestroy () {
    // this.signs = []
  }

  async mounted () {
    // console.log('mounted EPL')
    this.reSize()
    window.addEventListener('resize', this.reSize)
    this.tzoffset = new Date().getTimezoneOffset() * 60
    this.idxRoles = EPLModule.DictIdx('Roles')
    this.idx = EPLModule.DictIdx(this.dictName)
    EPLModule.hideDictForm(this.idx)
    // костыль для ожидания загрузки заголовков справочника ЭПЛ
    // и корректного фильтрования первого запроса
    let x = 0
    while (EPLModule.dicts[this.idx].headers.length === 0) {
      x++
      if (x > 3) {
        const e = {} as DictParam
        e.idx = this.idx
        e.request = {} as DictRequest
        e.request.options = { page: 1, itemsPerPage: 0 } as DictOptions
        await EPLModule.fetchDictData(e)
        break
      }
      await this.Wait()
    }
    // для выбора отображаемых столбцов в реестре ЭПЛ
    this.tableHeaders = Object.assign(this.tableHeaders, this.dict.headers)
    if (this.dictName === 'Organizations') {
      EPLModule.fetchHeadersList('DriverTasks')
    }
    if (this.dictName === 'Users') {
      await EPLModule.fetchList({ dict: 'CUTUNITS', sourcetext: 'CUTUNITS', sourcevalue: 'qwe' })
    }
    if (this.dictName === 'Drivers') {
      // список автоколонн
      await EPLModule.fetchList({ dict: 'DRIVERORG', sourcetext: '1', sourcevalue: '1' })
    }
    if (this.dictName === 'EPL') {
      const hh = localStorage.getItem('eplheaders')
      if (hh === null) {
        this.dict.headers.forEach((h: any) => {
          this.enabledHeaders.push(h.value)
        })
      } else {
        this.enabledHeaders = JSON.parse(hh)
        this.dict.headers.forEach((h: any) => {
          if (!this.enabledHeaders.includes(h.value)) {
            this.tableHeaders.splice(this.tableHeaders.indexOf(h), 1)
          }
        })
      }
      // список возможных отчётов
      this.idxR = EPLModule.DictIdx('ReportsList')
      const r = {} as DictParam
      r.idx = this.idxR
      r.request = {} as DictRequest
      r.request.options = { page: 1, itemsPerPage: -1 } as DictOptions
      r.request.filter = [] as Array<DictFilter>
      const rep = {} as DictFilter
      rep.field = 'isjournal'
      rep.condition = '0'
      rep.operator = '='
      rep.combine = 'AND'
      r.request.filter.push(rep)
      EPLModule.fetchDictData(r)
      // список транспорта и подразделений
      await EPLModule.fetchList({ dict: 'CUTUNITS', sourcetext: 'CUTUNITS', sourcevalue: 'qwe' })
      this.selectedEntUnits = [] as DictList
      if (this.hasEntUnits) {
        EPLModule.user.entunits.split(',').forEach((v) => {
          this.entUnits.forEach((e) => {
            if (e.value === v) {
              this.selectedEntUnits.push(e)
            }
          })
        })
      } else {
        const entUnits = localStorage.EntUnits
        if (entUnits === undefined) {
        } else {
          this.selectedEntUnits = JSON.parse(entUnits)
        }
      }

      this.idxS = EPLModule.DictIdx('Signs')
      this.massPdfToken = localStorage.massPdfToken
      if (this.massPdfToken === undefined) this.massPdfToken = ''
      this.startMassPdfTimer()
      const options = localStorage.Options
      if (options === undefined) {
        this.options.page = 1
        this.options.itemsPerPage = 10
      } else {
        this.options = JSON.parse(options)
      }
      this.optionsOld = JSON.stringify(this.options)
      const selected = localStorage.Selected
      if (selected !== undefined) this.selected = JSON.parse(selected)
      const extend = localStorage.ExtendFilter
      this.ExtendFilter = (extend === 'true')
      const signFilter = localStorage.signFilter
      if (signFilter !== undefined) this.signFilter = JSON.parse(signFilter)
      const spp = localStorage.SPP
      this.spp = (spp === 'true')
      const deleted = localStorage.deleted
      this.deleted = (deleted === 'true')
      const filter = localStorage.Filter
      if (filter !== undefined) {
        this.filter = filter
        this.filterString = filter
        this.currentFilterString = filter
      }
      this.currentFilter = `${filter}${JSON.stringify(this.selected)}`
      this.showArchived = localStorage.Archived === 'true'
      let period = localStorage.Period
      if (period === '-1') {
        this.dateFrom = localStorage.dateFrom
        this.dateTo = localStorage.dateTo
        this.changeFilter()
      } else {
        if (period === undefined) period = 1
        this.setPeriod(parseInt(period))
      }
    } else {
      this.changeFilter()
      if (this.mainFilter && this.mainFilter.field === 'eplid') {
        EPLModule.blockSignedFields({ idx: this.idx, eplid: parseInt(this.mainFilter.condition) })
      }
    }
  }

  get driverOrg () {
    return EPLModule.lists['DRIVERORG-DRIVERORG' as any]
  }

  get entUnits () {
    // console.log('entUnits')
    return EPLModule.lists['CUTUNITS-CUTUNITS' as any]
  }

  get userRole () {
    // console.log('userRole')
    return EPLModule.user.roleid
  }

  get hasEntUnits () {
    return EPLModule.user.entunits !== ''
  }

  get signed () {
    // console.log('signed')
    if (EPLModule.dicts[this.idx].name === 'EPL') return false
    return EPLModule.dicts[this.idx].signedFields.indexOf(';') >= 0
  }

  get dict () {
    // console.log('dict')
    return EPLModule.dicts[this.idx]
  }

  get reports () {
    // console.log('reports')
    return EPLModule.dicts[this.idxR].rows
  }

  private getReport (id: number) {
    const p = {} as DictRequest
    p.options = { page: 1, itemsPerPage: -1 }
    const entUnits = [] as Array<string>
    this.selectedEntUnits.forEach((e: any, i: number) => {
      if (typeof e === 'object') {
        entUnits.push(e.value)
      } else {
        this.selectedEntUnits.splice(i, 1)
      }
    })
    p.entunits = entUnits
    p.filter = this.fillFilter()
    EPLModule.getReport({ id: id, param: p })
      .then((response: any) => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        let filename = response.headers['content-disposition']
        filename = filename.substr(filename.search(/"/g) + 1)
        filename = filename.substr(0, filename.search(/"/g))
        link.href = url
        link.setAttribute('download', filename)
        document.body.appendChild(link)
        link.click()
      })
  }

  private setPeriod (period: number) {
    // console.log('setPeriod')
    switch (period) {
      case 0:
        this.dateFrom = moment().subtract(1, 'days').format('YYYY-MM-DD')
        this.dateTo = moment().subtract(1, 'days').format('YYYY-MM-DD')
        break
      case 1:
        this.dateFrom = moment().format('YYYY-MM-DD')
        this.dateTo = moment().format('YYYY-MM-DD')
        break
      case 2:
        this.dateFrom = moment().add(1, 'days').format('YYYY-MM-DD')
        this.dateTo = moment().add(1, 'days').format('YYYY-MM-DD')
        break
      case 3:
        this.dateFrom = moment().startOf('isoWeek').format('YYYY-MM-DD')
        this.dateTo = moment().endOf('isoWeek').format('YYYY-MM-DD')
        break
      case 4:
        this.dateFrom = moment().startOf('month').format('YYYY-MM-DD')
        this.dateTo = moment().endOf('month').format('YYYY-MM-DD')
        break
    }
    this.period = period
    localStorage.Period = period
    this.changeFilter()
  }

  private changeExtendFilter () {
    if (!this.ExtendFilter) this.selected.splice(0, this.selected.length)
    localStorage.Selected = JSON.stringify(this.selected)
    localStorage.ExtendFilter = this.ExtendFilter
    this.reSize()
  }

  private changeArchived () {
    this.showArchived = !this.showArchived
    localStorage.Archived = this.showArchived
    this.changeFilter()
  }

  private changeDismissed () {
    this.dismissed = !this.dismissed
    this.changeFilter()
  }

  private changeDeleted () {
    this.deleted = !this.deleted
    localStorage.deleted = this.deleted
    this.changeFilter()
  }

  private changeSpp () {
    localStorage.SPP = this.spp
    this.changeFilter()
  }

  private changeEntUnits () {
    localStorage.EntUnits = JSON.stringify(this.selectedEntUnits)
    this.changeFilter()
  }

  get dateFormattedFrom () {
    // console.log('dateFormattedFrom')
    return moment.unix(this.getUnixTime(this.dateFrom)).format('DD.MM.YYYY')
  }

  get dateFormattedTo () {
    // console.log('dateFormattedTo')
    return moment.unix(this.getUnixTime(this.dateTo)).format('DD.MM.YYYY')
  }

  private getUnixTime (date: string): number {
    // console.log('getUnixTime')
    return parseInt(
      ((new Date(date).getTime() / 1000) + this.tzoffset).toFixed(0)
    )
  }

  private clickClose () {
    EPLModule.hideDictForm(this.idx)
  }

  private correctDateTime (date: number) {
    // console.log('correctDateTime')
    if (date === 0) return '-'
    return moment.unix(date).format('DD.MM.YYYY HH:mm')
  }

  private correctDate (date: number) {
    // console.log('correctDate')
    if (date === 0) return '-'
    return moment.unix(date).format('DD.MM.YYYY')
  }

  private getTime (date: number) {
    // console.log('getTime')
    return moment.unix(date).format('HH:mm')
  }

  // get disableFilter () {
  //   if (this.ExtendFilter) {
  //     if (this.selected.length === 0) return true
  //   }
  //   // const changes = `${this.currentFilterString}${JSON.stringify(this.selected)}`
  //   // if (this.currentFilter === changes) return true
  //   // if (this.currentFilterString === null) return true
  //   // if (this.currentFilterString.length > 2) return false
  //   return true
  // }

  private changeFilterString (args: any) {
    // console.log('changeFilterString', args)
    if (args === null) {
      this.currentFilterString = ''
      this.applyFilter()
      return
    }
    if (typeof args === 'string') {
      this.currentFilterString = args
      if (args === '') this.applyFilter()
      return
    }
    if (args.target !== undefined) {
      this.currentFilterString = args.target.value
      if (args.key === 'Enter') {
        this.applyFilter()
      }
      if (this.currentFilterString === '') {
        this.applyFilter()
      }
      // else this.filter = filter.replace(/[^ -a-zа-яё0-9.]/ig, '')
    }
    // console.log('changeFilterString', this.currentFilterString)
  }

  private applyFilter () {
    // console.log('applyFilter')
    this.filter = this.currentFilterString
    let filter = this.currentFilterString
    filter = filter.replace(/[^ a-zа-яё0-9.]/ig, '')
    this.filterString = filter
    const changes = `${filter}${JSON.stringify(this.selected)}`
    if (this.currentFilter !== changes) {
      this.currentFilter = changes
      if (filter === '' || filter.length > 0) {
        if (this.dictName === 'EPL') {
          localStorage.Filter = filter
          localStorage.Selected = JSON.stringify(this.selected)
          localStorage.ExtendFilter = this.ExtendFilter
        }
        this.filterError = false
        this.options.page = 1
        this.changeFilter()
      } else {
        this.filterError = true
      }
    }
  }

  private fillFilter (): Array<DictFilter> {
    // console.log('fillFilter')
    const filter = [] as Array<DictFilter>
    // Фильтр уволенных водителей
    if (this.dictName === 'Drivers') {
      const d = {} as DictFilter
      d.field = 'deleted'
      d.condition = `${this.dismissed ? '1' : '0'}`
      d.operator = '='
      d.combine = 'AND'
      filter.push(d)
      if (this.selectedDriverOrg != null) {
        d.field = 'org'
        d.condition = `${this.selectedDriverOrg.value}`
        d.operator = '='
        d.combine = 'AND'
        filter.push(d)
      }
    }
    // добавим фильтр периода для ЭПЛ
    if (this.dictName === 'EPL' && this.dateFrom !== '') {
      const from = {} as DictFilter
      from.field = 'departureplanetime'
      from.condition = `${this.getUnixTime(this.dateFrom)}`
      from.operator = '>='
      from.combine = 'AND'
      filter.push(from)
      const to = {} as DictFilter
      to.field = 'departureplanetime'
      to.condition = `${this.getUnixTime(this.dateTo) + 86399}`
      to.operator = '<='
      to.combine = 'AND'
      filter.push(to)
      const arch = {} as DictFilter
      arch.field = 'archived'
      let cond = '0'
      if (this.showArchived) cond = '1'
      arch.condition = `${cond}`
      arch.operator = '='
      arch.combine = 'AND'
      filter.push(arch)
      if (EPLModule.user.roleid === 7) {
        // для водителя только ПЛ где он водитель
        const drv = {} as DictFilter
        drv.field = 'driver1'
        drv.condition = `${EPLModule.user.driverid}`
        drv.operator = '='
        drv.combine = 'AND'
        filter.push(drv)
      }
    }
    // Фильтр удалённых ПЛ
    if (this.dictName === 'EPL') {
      const d = {} as DictFilter
      d.field = 'deleted'
      d.condition = `${this.deleted ? '1' : '0'}`
      d.operator = '='
      d.combine = 'AND'
      filter.push(d)
    }
    if (this.showFilter) {
      if (this.filter !== null && this.filter.length > 0) {
        EPLModule.dicts[this.idx].headers
          .forEach((h: any) => {
            if (!this.ExtendFilter || this.selected.indexOf(h.value) !== -1) {
              if (h.type === 'select') {
                // для полей списков ищем в списке и передаем найденные uid`ы
                const list = `${h.source}-${h.sourcetext}` as any
                const vals = [] as Array<string>
                if (EPLModule.lists[list] !== undefined) {
                  EPLModule.lists[list].forEach((l: any) => {
                    if (l.text.toLowerCase().search(this.filter.toLowerCase()) !== -1) {
                      vals.push(l.value)
                    }
                  })
                }
                if (vals.length > 0) {
                  let cond = JSON.stringify(vals)
                  cond = cond.replace(/"/g, '\'')
                  cond = cond.replace('[', '(')
                  cond = cond.replace(']', ')')
                  const f = {} as DictFilter
                  f.field = h.value
                  f.condition = cond
                  f.operator = 'IN'
                  f.combine = 'OR'
                  filter.push(f)
                }
              }
              if (h.type === 'number' || h.type === undefined) {
                const f = {} as DictFilter
                f.field = h.value
                f.condition = `%${this.filter}%`
                f.operator = 'LIKE'
                f.combine = 'OR'
                filter.push(f)
              }
            }
          })
        // возможно искали в поле типа select и не нашли,
        // значит нужно добавить фильтр, который гарантирует возврат пустого массива
        if (this.dictName === 'EPL') {
          if (filter.length === 4 || (filter.length === 5 && EPLModule.user.roleid === 7)) {
            const f = {} as DictFilter
            f.field = 'id'
            f.condition = '-1'
            f.operator = '='
            f.combine = 'OR'
            filter.push(f)
          }
        } else {
          if (filter.length === 0) {
            const f = {} as DictFilter
            f.field = 'id'
            f.condition = '-1'
            f.operator = '='
            f.combine = 'OR'
            filter.push(f)
          }
        }
      }
    } else {
      filter.push(this.mainFilter)
    }
    return filter
  }

  private changeFilter () {
    // console.log('changeFilter')
    const p = {} as DictParam
    p.idx = this.idx
    p.request = {} as DictRequest
    p.request.options = this.options as DictOptions
    // опции для корректной сортировки
    const destfield = p.request.options.sortBy && p.request.options.sortBy[0]
    let type = ''
    let table = ''
    let field = ''
    let sourcefield = ''
    if (destfield !== undefined) {
      EPLModule.dicts[this.idx].headers.forEach((h: any) => {
        if (h.value === destfield) {
          type = h.type
          table = h.source
          field = h.sourcevalue
          sourcefield = h.sourcetext
        }
      })
      if (type === 'select') {
        p.request.orderoption = {} as OrderOption
        p.request.orderoption.table = table
        p.request.orderoption.field = field
        p.request.orderoption.sourcefield = sourcefield
        // console.log(p.request.orderoption)
      }
    }
    if (this.dictName === 'EPLjournal' || this.dictName === 'ActionJournal') {
      if (p.request.options.sortBy && p.request.options.sortBy.length === 0) {
        p.request.options.sortBy = ['date']
        p.request.options.sortDesc = [true]
      }
    }
    if (this.dictName === 'DriverTasks') {
      p.request.options.itemsPerPage = -1
      p.request.options.sortBy = ['arrivedtime']
      p.request.options.sortDesc = [false]
    }
    // if (this.dictName === 'GalaxyReqList') {
    //   p.request.options.sortBy = ['reqtime']
    //   p.request.options.sortDesc = [true]
    // }
    if (this.dictName === 'EPL') {
      const entUnits = [] as Array<string>
      this.selectedEntUnits.forEach((e: any, i: number) => {
        if (typeof e === 'object') {
          entUnits.push(e.value)
        } else {
          this.selectedEntUnits.splice(i, 1)
        }
      })
      p.request.entunits = entUnits
      if (p.request.options.sortBy && p.request.options.sortBy.length === 0) {
        p.request.options.sortBy = ['date']
        p.request.options.sortDesc = [true]
      }
      if (this.spp) {
        if (EPLModule.user.organization === '') p.request.spp = '---'
        else p.request.spp = EPLModule.user.organization
      }
      // фильтр по отсутствующим подписям
      p.request.signFilter = []
      let r2 = 0
      if (this.signFilter.r2.out) r2 += 1
      if (this.signFilter.r2.in) r2 += 2
      if (r2 > 0) p.request.signFilter.push({ roleid: 2, ftype: r2 })
      let r3 = 0
      if (this.signFilter.r3.out) r3 += 1
      if (this.signFilter.r3.in) r3 += 2
      if (r3 > 0) p.request.signFilter.push({ roleid: 3, ftype: r3 })
      let r4 = 0
      if (this.signFilter.r4.out) r4 += 1
      if (this.signFilter.r4.in) r4 += 2
      if (r4 > 0) p.request.signFilter.push({ roleid: 4, ftype: r4 })
      let r7 = 0
      if (this.signFilter.r7.out) r7 += 1
      if (this.signFilter.r7.in) r7 += 2
      if (r7 > 0) p.request.signFilter.push({ roleid: 7, ftype: r7 })
    }
    p.request.filter = this.fillFilter()
    EPLModule.fetchDictData(p)
      .then(() => {
        // console.log('end fetch')
        if (this.dictName === 'DriverTasks') {
          this.calcPlaneTime()
        }
        if (this.dictName === 'EPL') {
          if (EPLModule.dicts[this.idx].rowsCount > 0) {
            this.signs = []
            // const signs = [] as Array<{ name0: string, name1: string, sign0: number, sign1: number, date0: string, date1: string }>
            EPLModule.dicts[this.idxS].rows.forEach(s => {
              const id = `${s.eplid}-${s.role}` as any
              if (this.signs[id] === undefined) this.signs[id] = { name0: '', name1: '', sign0: -1, sign1: -1, date0: '', date1: '' }
              if (s.eventtype === 0) {
                this.signs[id].sign0 = s.signtype
                this.signs[id].date0 = moment.unix(s.date).format('HH:mm')
                if (s.signtype < 2) this.signs[id].name0 = s.autor
              }
              if (s.eventtype === 1) {
                this.signs[id].sign1 = s.signtype
                if (s.date === 0) { this.signs[id].date1 = '' } else { this.signs[id].date1 = moment.unix(s.date).format('HH:mm') }
                if (s.signtype < 2) this.signs[id].name1 = s.autor
              }
            })
            // this.signs = signs.map((item: any) => Object.freeze(item))
            // signs.length = 0
            // })
          }
        }
        this.show = true
      })
  }

  private async calcPlaneTime () {
    // console.log('calcPlaneTime')
    // рассчёт планового времени
    const idx = EPLModule.DictIdx('EPL')
    const idxR = EPLModule.DictIdx('Repairs')
    const idxD = EPLModule.DictIdx('Downtimes')
    const beg = EPLModule.dicts[idx].currentRow.departurefacttime
    const end = EPLModule.dicts[idx].currentRow.arrivedfacttime
    const dbeg = EPLModule.dicts[idx].currentRow.dinnerbegin
    const dend = EPLModule.dicts[idx].currentRow.dinnerend
    this.dinner = Math.ceil((dend - dbeg) / 60)
    this.eplhours = Math.ceil((end - beg) / 60)
    const pr = {} as DictParam
    pr.idx = idxR
    pr.request = {} as DictRequest
    pr.request.options = {} as DictOptions
    pr.request.options.page = 1
    pr.request.options.itemsPerPage = -1
    pr.request.filter = [] as DictFilter[]
    pr.request.filter.push(this.mainFilter)
    await EPLModule.fetchDictData(pr)
    this.repairs = 0
    EPLModule.dicts[idxR].rows.forEach(r => {
      let dinner = 0
      this.repairs += Math.ceil((r.timeend - r.timebegin) / 60)
      // обед полностью попал в простой
      if (r.timebegin <= dbeg && r.timeend >= dend) dinner = dend - dbeg
      // обед закончился в простой
      else if (r.timebegin >= dbeg && r.timeend >= dend) dinner = dend - r.timebegin
      // обед начался в простой
      else if (r.timebegin <= dbeg && r.timeend <= dend) dinner = r.timeend - dbeg
      if (dinner > 0) this.repairs -= Math.ceil(dinner / 60)
    })
    const pd = {} as DictParam
    pd.idx = idxD
    pd.request = {} as DictRequest
    pd.request.options = {} as DictOptions
    pd.request.options.page = 1
    pd.request.options.itemsPerPage = -1
    pd.request.filter = [] as DictFilter[]
    pd.request.filter.push(this.mainFilter)
    await EPLModule.fetchDictData(pd)
    this.downtimes = 0
    EPLModule.dicts[idxD].rows.forEach(r => {
      let dinner = 0
      this.downtimes += Math.ceil((r.finish - r.start) / 60)
      // обед полностью попал в простой
      if (r.start <= dbeg && r.finish >= dend) dinner = dend - dbeg
      // обед закончился в простой
      else if (r.start >= dbeg && r.finish >= dend) dinner = dend - r.start
      // обед начался в простой
      else if (r.start <= dbeg && r.finish <= dend) dinner = r.finish - dbeg
      if (dinner > 0) this.downtimes -= Math.ceil(dinner / 60)
    })
    this.drivertasks = 0
    EPLModule.dicts[this.idx].rows.forEach(r => {
      let dinner = 0
      const clientarrivedtime = r.clientarrivedtime === 0 ? r.arrivedtime : r.clientarrivedtime
      this.drivertasks += Math.ceil((r.clientdeparturetime - clientarrivedtime) / 60)
      // console.log(clientarrivedtime, r.clientdeparturetime, dbeg, dend)
      // обед полностью попал в СЗ
      if (clientarrivedtime <= dbeg && r.clientdeparturetime >= dend) dinner = dend - dbeg
      // обед закончился в СЗ
      else if (clientarrivedtime >= dbeg && r.clientdeparturetime >= dend) dinner = dend - clientarrivedtime
      // обед начался в СЗ
      else if (clientarrivedtime <= dbeg && r.clientdeparturetime <= dend) dinner = r.clientdeparturetime - dbeg
      if (dinner > 0) this.drivertasks -= Math.ceil(dinner / 60)
    })
    this.diff = this.eplhours - this.drivertasks - this.dinner - this.downtimes - this.repairs
  }

  private changePeriod () {
    // console.log('changePeriod')
    this.period = -1
    localStorage.Period = -1
    if (this.dateFrom > this.dateTo) this.dateTo = this.dateFrom
    localStorage.dateFrom = this.dateFrom
    localStorage.dateTo = this.dateTo
    this.changeFilter()
  }

  private getSelectValue (value: string | number, list: any): string {
    // console.log('getSelectValue')
    let result = ''
    if (EPLModule.lists[list]) {
      if (typeof value === 'string' && value.includes(' ')) {
        const values = value.split(' ')
        const l = EPLModule.lists[list]
        values.forEach(v => {
          for (let i = 0; i < l.length; i++) {
            if (l[i].value === v) {
              result += l[i].text + ', '
              break
            }
          }
        })
        result = result.substring(0, result.length - 2)
      } else {
        const l = EPLModule.lists[list]
        for (let i = 0; i < l.length; i++) {
          if (l[i].value === value || l[i].value === `${value}`) {
            result = l[i].text
            break
          }
        }
      }
    }
    return result
  }

  private deleteItem (item: any): void {
    if (this.dict.locked.del) return
    if (confirm('Удалить запись?')) {
      EPLModule.delDictRow({ id: item.id, idx: this.idx })
        .then(() => {
          if (this.dictName === 'DriverTasks') this.calcPlaneTime()
        })
    }
  }

  private editItem (id: number): void {
    if (id === 0 && this.customAdd) {
      this.clickAdd()
      return
    }
    EPLModule.showDictForm({ id: id, idx: this.idx })
    if ((this.dictName === 'Downtimes' || this.dictName === 'Repairs') && id === 0) {
      const idxEPL = EPLModule.DictIdx('EPL')
      if (this.dictName === 'Downtimes') {
        EPLModule.dicts[this.idx].currentRow.start = EPLModule.dicts[idxEPL].currentRow.departureplanetime
        EPLModule.dicts[this.idx].currentRow.finish = EPLModule.dicts[idxEPL].currentRow.arrivedplanetime
      }
      if (this.dictName === 'Repairs') {
        EPLModule.dicts[this.idx].currentRow.timebegin = EPLModule.dicts[idxEPL].currentRow.departureplanetime
        EPLModule.dicts[this.idx].currentRow.timeend = EPLModule.dicts[idxEPL].currentRow.arrivedplanetime
      }
    }
    if (this.dictName === 'DriverTasks' && id === 0) {
      // поиск предыдущего задания
      let maxtime = 0
      let maxid = -1
      EPLModule.dicts[this.idx].rows.forEach((r, i) => {
        if (r.arrivedtime > maxtime) {
          maxid = i
          maxtime = r.arrivedtime
        }
      })
      const idxEPL = EPLModule.DictIdx('EPL')
      if (maxid === -1) {
        // это первое задание, ставим время по плану ЭПЛ
        EPLModule.dicts[this.idx].currentRow.arrivedmileage = EPLModule.dicts[idxEPL].currentRow.departuretotalmileage
        EPLModule.dicts[this.idx].currentRow.arrivedtime = EPLModule.dicts[idxEPL].currentRow.departureplanetime
        EPLModule.dicts[this.idx].currentRow.clientarrivedtime = EPLModule.dicts[idxEPL].currentRow.departureplanetime
        EPLModule.dicts[this.idx].currentRow.driverarrivedtime = EPLModule.dicts[idxEPL].currentRow.departureplanetime
        EPLModule.dicts[this.idx].currentRow.departuretime = EPLModule.dicts[idxEPL].currentRow.arrivedplanetime
        EPLModule.dicts[this.idx].currentRow.clientdeparturetime = EPLModule.dicts[idxEPL].currentRow.arrivedplanetime
        EPLModule.dicts[this.idx].currentRow.driverdeparturetime = EPLModule.dicts[idxEPL].currentRow.arrivedplanetime
      } else {
        // есть предыдущее задание
        EPLModule.dicts[this.idx].currentRow.arrivedmileage = EPLModule.dicts[this.idx].rows[maxid].departuremileage
        EPLModule.dicts[this.idx].currentRow.arrivedtime = EPLModule.dicts[this.idx].rows[maxid].departuretime
        EPLModule.dicts[this.idx].currentRow.clientarrivedtime = EPLModule.dicts[this.idx].rows[maxid].departuretime
        EPLModule.dicts[this.idx].currentRow.driverarrivedtime = EPLModule.dicts[this.idx].rows[maxid].departuretime
        EPLModule.dicts[this.idx].currentRow.departuretime = EPLModule.dicts[idxEPL].currentRow.arrivedplanetime
        EPLModule.dicts[this.idx].currentRow.clientdeparturetime = EPLModule.dicts[idxEPL].currentRow.arrivedplanetime
        EPLModule.dicts[this.idx].currentRow.driverdeparturetime = EPLModule.dicts[idxEPL].currentRow.arrivedplanetime
      }
    }
  }

  private clickItem (item: any): void {
    // console.log('clickItem')
    let click = false
    EPLModule.dicts[this.idx].formfields.forEach((tab: any) => {
      tab.data.forEach((t: any) => {
        // костыль для обновления списка полей справочника для AccessTable
        if (t.type === 'atselect') {
          click = true
          EPLModule.dicts[this.idx].rows.forEach((e: any) => {
            if (e.id === item.id) {
              EPLModule.fetchHeadersList(e[t.value]).then(() => {
                this.clickRow(item.id)
              })
            }
          })
        }
      })
    })
    if (!click) this.clickRow(item.id)
  }

  private viewSignXML (id: number) {
    this.myxml.splice(0, this.myxml.length)
    this.showSignXMLDialog = true
    this.loadingCert = true
    EPLModule.getSignTaskXMLFile(id).then(
      async (response: any) => {
        const parser = new DOMParser()
        const xmlDoc = parser.parseFromString(response.data, 'text/xml')
        const x = xmlDoc.documentElement.childNodes
        let val: string | null
        for (let i = 0; i < x.length; i++) {
          if (x[i].childNodes[0] === undefined) {
            val = ''
          } else {
            val = x[i].childNodes[0].nodeValue
          }
          this.myxml.push({ key: x[i].nodeName, val: val })
        }
        try {
          this.provider = await SIGNModule.checkSignXML(response.data)
          this.loadingCert = false
        } catch (e) {
          this.loadingCert = false
          this.provider = [e]
        }
      }
    )
  }

  private getSignBtn (): boolean {
    let qsign = false
    EPLModule.dicts[this.idxRoles].rows.forEach((s: any) => {
      if (s.id === this.userRole) qsign = s.qsign
    })
    return qsign
  }

  private async signEPL (thumbprint: string) {
    if (thumbprint === '-') {
      // простая подпись
      this.loadingSimple = true
      EPLModule.setSignSimple({ id: this.signCurrentId, event: this.signEventType, login: this.iLogin, password: this.iPassword })
        .then((response) => {
          this.signEventType = -1
          this.signCurrentId = -1
          this.showSignSimpleDialog = false
          this.loadingSimple = false
          this.changeFilter()
          console.log(response)
        })
        .catch(() => (this.loadingSimple = false))
    } else {
      // квалифицированная подпись
      let cert = ''
      this.certificates.forEach(c => {
        if (c.thumbprint === thumbprint) {
          const t = c.name.match(/T=([А-Яа-я\s]+),/)
          const sn = c.name.match(/SN=([А-Яа-я\s]+),/)
          const g = c.name.match(/G=([А-Яа-я\s]+),/)
          let tt = ''
          let tsn = ''
          let tg = ''
          if (t !== null) tt = t[1]
          if (sn !== null) tsn = sn[1]
          if (g !== null) tg = g[1]
          cert = `${tt}, ${tsn} ${tg}, № ${c.serial} действителен с ${c.fromdate} по ${c.todate}`
        }
      })
      await SIGNModule.signXML({ thumbprint: thumbprint, data: this.XMLtoSign })
        .then(sign => {
          EPLModule.setSignXMLFile({ id: this.signCurrentId, event: this.signEventType, cert: cert, data: sign })
        })
        .catch(e => {
          console.log(e)
          EPLModule.setError(e)
        })
      this.certificates = []
      this.signEventType = -1
      this.signCurrentId = -1
      this.showSignXMLDialog = false
      this.changeFilter()
    }
  }

  private async onSign (eventtype: number, id: number, qsign: boolean) {
    this.signEventType = eventtype
    this.signCurrentId = id
    if (qsign) {
      // квалифицированная подпись
      this.myxml.splice(0, this.myxml.length)
      this.showSignXMLDialog = true
      this.loadingCert = true
      EPLModule.getSignXMLFile({ id: id, event: eventtype, role: 4 }).then(
        (response: any) => {
          this.XMLtoSign = response.data
          const parser = new DOMParser()
          const xmlDoc = parser.parseFromString(response.data, 'text/xml')
          const x = xmlDoc.documentElement.childNodes
          let val: string | null
          for (let i = 0; i < x.length; i++) {
            if (x[i].childNodes[0] === undefined) {
              val = ''
            } else {
              val = x[i].childNodes[0].nodeValue
            }
            this.myxml.push({ key: x[i].nodeName, val: val })
          }
        }
      )
      try {
        const provider = await SIGNModule.checkProvider()
        this.provider = [provider]
        this.certificates = await SIGNModule.getCertificates()
        this.loadingCert = false
      } catch (e) {
        this.loadingCert = false
        this.provider = [e]
      }
    } else {
      // простая подпись
      this.iLogin = EPLModule.user.tabn
      this.showSignSimpleDialog = true
    }
  }

  private async onSignTask (id: number, qsign: boolean) {
    this.signedTask = id
    if (qsign) {
      // квалифицированная подпись
      this.myxml.splice(0, this.myxml.length)
      this.showSignXMLDialog = true
      this.loadingCert = true
      EPLModule.getTaskXMLFile(id).then(
        (response: any) => {
          this.XMLtoSign = response.data
          const parser = new DOMParser()
          const xmlDoc = parser.parseFromString(response.data, 'text/xml')
          const x = xmlDoc.documentElement.childNodes
          let val: string | null
          for (let i = 0; i < x.length; i++) {
            if (x[i].childNodes[0] === undefined) {
              val = ''
            } else {
              val = x[i].childNodes[0].nodeValue
            }
            this.myxml.push({ key: x[i].nodeName, val: val })
          }
        }
      )
      try {
        const provider = await SIGNModule.checkProvider()
        this.provider = [provider]
        this.certificates = await SIGNModule.getCertificates()
        this.loadingCert = false
      } catch (e) {
        this.loadingCert = false
        this.provider = [e]
      }
    } else {
      // простая подпись
      this.iLogin = EPLModule.user.tabn
      this.showSignSimpleDialog = true
    }
  }

  private async signTask (thumbprint: string) {
    // console.log('signTask')
    if (thumbprint === '-') {
      // простая подпись
      this.loadingSimple = true
      EPLModule.setSignTaskIDO({ id: this.signedTask, login: this.iLogin, password: this.iPassword })
        .then(() => {
          this.showSignSimpleDialog = false
          this.loadingSimple = false
          this.changeFilter()
        })
        .catch(() => (this.loadingSimple = false))
    } else {
      // квалифицированная подпись
      const sign = await SIGNModule.signXML({ thumbprint: thumbprint, data: this.XMLtoSign })
      await EPLModule.setSignTaskXMLFile({ id: this.signedTask, data: sign })
      this.certificates = []
      this.showSignXMLDialog = false
      this.changeFilter()
    }
  }

  private reSize () {
    if (this.builtin) {
      this.tableHeight = '100%'
    } else {
      let k = 0
      if (this.dictName === 'EPL') k = 300
      else k = 230
      if (this.dictName === 'Repairs') k += 48
      if (this.dictName === 'Downtimes') k += 48
      if (this.dictName === 'FuelFills') k += 48
      if (this.dictName === 'DriverTasks') k -= 10
      if (this.ExtendFilter) k += 48
      this.tableHeight = window.innerHeight - k
    }
  }
}
